import React from "react";
import "./Favourites.scss";
import PizzaHut from "../../Images/Pizza_Hut.png";
import Burger_King from "../../Images/Burger_King.png";
import Haldiram from "../../Images/Haldiram.png";
import Subway from "../../Images/Subway.png";
import Bikanerwala from "../../Images/Bikanerwala.png";
import rl1 from "../../Images/rl1.png";
import rl2 from "../../Images/rl2.png";
import rl4 from "../../Images/rl4.png";
import rl5 from "../../Images/rl5.png";
import rl6 from "../../Images/rl6.png";
import rl7 from "../../Images/rl7.png";
import rl8 from "../../Images/rl8.png";
import rl9 from "../../Images/rl9.png";
import rl10 from "../../Images/rl10.png";
import rl11 from "../../Images/rl11.png";
import rl12 from "../../Images/rl12.png";
import Marquee from "react-fast-marquee";

const Favourites = () => {
  const data=[rl1,rl2,rl4,rl5,rl6,rl7,rl8,rl9,rl10,rl11,rl12]
  return (
    <div>
      <div className="favourites_main_wrapper">
        <div className="upper_wrapper">
          {/* <div className="text_key">Restaurant Hall Of Fame</div> */}
          <div className="text_value">Restaurant Hall Of Fame</div>
        </div>

        <div className="favourites_lower_wrapper">
          {/* <div className="favoriate_inner">
            <img src={PizzaHut} className="item_image"/>
          </div>
          <div className="favoriate_inner">
            <img src={Subway} className="item_image"/>
          </div>
          <div className="favoriate_inner">
            <img src={Haldiram} className="item_image"/>
          </div>
          <div className="favoriate_inner">
            <img src={Burger_King} className="item_image"/>
          </div>
          <div className="favoriate_inner">
            <img src={Bikanerwala} className="item_image"/>
          </div> */}
           <Marquee>
          {
            data.map((item,index)=>{
              return(
                <div className="hof_wrapper" key={index}>
                <img src={item} className="hof_image"/>
              </div>
              )
            })
          }
          </Marquee>
        </div>
      </div>
    </div>
  );
};

export default Favourites;
